import {gql, useQuery} from "@apollo/client";

const QUERY = gql`
query getMaintenanceWindow($locale: String!){
    spaMaintenanceWindowsCollection(locale: $locale) {
        items {
          image {
            url
          },
          title,
          text
        }
    }
}`;

export const useMaintenanceWindow = (locale) => {
    const {loading, data} = useQuery(QUERY, {variables: {locale}, errorPolicy: "all"});
    const maintenanceDetails = data?.spaMaintenanceWindowsCollection?.items[0];

    return {
        maintenanceDetails,
        isMaintenanceWindowOpen: !!maintenanceDetails,
        loadingMaintenance: loading,
    };
};
